/* tslint:disable */
import {
  NotificationChain
} from '../index';

declare var Object: any;
export interface NotificationInterface {
  "text": string;
  "personalised"?: boolean;
  "send"?: Date;
  "id"?: any;
  "chainId"?: any;
  "created"?: Date;
  chain?: NotificationChain;
}

export class Notification implements NotificationInterface {
  "text": string;
  "personalised": boolean;
  "send": Date;
  "id": any;
  "chainId": any;
  "created": Date;
  chain: NotificationChain;
  constructor(data?: NotificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Notification`.
   */
  public static getModelName() {
    return "Notification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Notification for dynamic purposes.
  **/
  public static factory(data: NotificationInterface): Notification{
    return new Notification(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Notification',
      plural: 'Notifications',
      path: 'Notifications',
      idName: 'id',
      properties: {
        "text": {
          name: 'text',
          type: 'string'
        },
        "personalised": {
          name: 'personalised',
          type: 'boolean',
          default: false
        },
        "send": {
          name: 'send',
          type: 'Date',
          default: new Date(0)
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "chainId": {
          name: 'chainId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        chain: {
          name: 'chain',
          type: 'NotificationChain',
          model: 'NotificationChain',
          relationType: 'belongsTo',
                  keyFrom: 'chainId',
          keyTo: 'id'
        },
      }
    }
  }
}
